module.exports = __webpack_public_path__ + "static/media/roadside-assistance_color.2a61ddfe.png";